import { render } from "./tuttorial.vue?vue&type=template&id=8bfc2fc4&bindings={\"navigate\":\"props\"}"
import script from "./tuttorial.vue?vue&type=script&lang=js"
export * from "./tuttorial.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./tuttorial.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script